import { FaCubes } from "react-icons/fa";
import { RiMoneyDollarBoxLine } from "react-icons/ri";
import ControlPanalSyncProduct from "./controlPanalSyncProduct";
import ControlPanalSyncLtpPrice from "./controlPanalSyncLtpPrice";

function ControlPanel() {
  return (
    <>
      <div>
        <ul
          className="flex flex-col flex-wrap justify-center pl-0 mt-2 mb-1 list-none border-b-0 md:flex-row"
          role="tablist"
          data-te-nav-ref
        >
          <li role="presentation">
            <a
              href="#tabs-sync-product"
              className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-violet data-[te-nav-active]:text-violet dark:text-neutral-400 dark:hover:bg-transparent data-[te-nav-active]:border-violet-400 data-[te-nav-active]:text-violet-400"
              data-te-toggle="pill"
              data-te-target="#tabs-sync-product"
              data-te-nav-active
              role="tab"
              aria-controls="tabs-sync-product"
              aria-selected="true"
            >
              <div className="flex items-center gap-2">
                <FaCubes size={20} />
                <span className="">Sync Products</span>
              </div>
            </a>
          </li>
          <li role="presentation">
            <a
              href="#tabs-sync-ltp-price"
              className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-violet data-[te-nav-active]:text-violet dark:text-neutral-400 dark:hover:bg-transparent data-[te-nav-active]:border-yellow-500 data-[te-nav-active]:text-yellow-500"
              data-te-toggle="pill"
              data-te-target="#tabs-sync-ltp-price"
              // data-te-nav-active
              role="tab"
              aria-controls="tabs-sync-ltp-price"
              aria-selected="true"
            >
              <div className="flex items-center gap-2">
                <RiMoneyDollarBoxLine size={20} />
                <span className="">Sync LTP Price</span>
              </div>
            </a>
          </li>
        </ul>

        <div className="mb-1">
          <div
            className="hidden opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-sync-product"
            role="tabpanel"
            aria-labelledby="tabs-sync-product-tab"
            data-te-tab-active
          >
            <div className="mb-6 px-6">
              <ControlPanalSyncProduct />
            </div>
          </div>
          <div
            className="hidden opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-sync-ltp-price"
            role="tabpanel"
            aria-labelledby="tabs-sync-ltp-price-tab"
            // data-te-tab-active
          >
            <div className="mb-6 px-6">
              <ControlPanalSyncLtpPrice />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ControlPanel;
